import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SignNotificationItem } from '../model/sign-notification-Item';

const CONTROLLER = 'notification';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  onNotificationCounterChanged = new EventEmitter<number>();

  constructor(private http: HttpClient) { }

  get(): Observable<SignNotificationItem[]> {
    return this.http.get<SignNotificationItem[]>(`${CONTROLLER}`)
      .pipe(
        map((data: any) => data)
      );
  }

  getCount(): Observable<number> {
    return this.http.get(`${CONTROLLER}`.concat('/count')).pipe(
      map((data: any) => data)
    );
  }

  deleteNotification(id: number | number[]): Observable<void> {
    if (Array.isArray(id)) {
      const params = { id: id.map((i) => i.toString()) };
      return this.http.delete<void>(`${CONTROLLER}/`, { params });
    }
    return this.http.delete<void>(`${CONTROLLER}/${id}`);
  }

  setToRead(id: number): Observable<void> {
    return this.http.put<void>(`${CONTROLLER}/SetToRead/${id}`, null);
  }
}
